import type { RecordedTtvAnalyticsEvent } from "@/app/(application)/(ttv)/ttv/analytics/types";
import { createBoundedEventRing } from "@/app/(application)/(ttv)/ttv/createBoundedEventRing";

// Enough history to reconstruct a session's funnel by hand while debugging, without letting a long editing session grow the trail unbounded.
const MAX_RECENT_EVENTS = 100;

// The product-analytics trail. It is what lets the tests assert a sanitized payload without standing up PostHog, and what keeps diagnostics available when browser capture is missing or throws.
export const ttvAnalyticsEventRing =
  createBoundedEventRing<RecordedTtvAnalyticsEvent>(MAX_RECENT_EVENTS);
